export default __webpack_public_path__ + "static/media/illus2.c88497d2.jpg";